import React from "react";
import { IButtonProps, CommandBarButton } from "@fluentui/react";

const CustomButton = (props: IButtonProps): any => {
  const color = props.disabled ? "rgb(200, 198, 196)" : "#333";
  return (
    <CommandBarButton
      {...props}
      styles={{
        ...props.styles,
        textContainer: { color },
        icon: { color: "var(--main-bg-color, gray)" }
      }}
    />
  );
};

export default CustomButton;
